const config = require('../../../../../config/locales_json/packs/private/validations/modify_password.json');
const language = $('body').data("language");

/**************************************************
 * 
 *    V A L I D A C I O N E S    U S U A R I O
 * 
*/
$("#kt_login_modify_form #kt_login_modify_submit").on("click", function(e){
  e.preventDefault()

  var error = 0
  var password = $("#kt_login_modify_form #user_password")
  var rePassword = $("#kt_login_modify_form #user_password_confirmation")

  if(!password.val()){
    const errorText = getTranslationValue(config, [language, "user_empty_password"],"Debes ingresar una contraseña");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().find(".help-block").before('<div class="invalid-feedback js-error">'+errorText+'</div>')
    //console.log("No hay contraseña");
    error++
  } if(password.val().length < 6){
    const errorText = getTranslationValue(config, [language, "user_short_password"],"Debes ingresar la cantidad de cararcteres indicados");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().find(".help-block").before('<div class="invalid-feedback js-error">'+errorText+'</div>')
    //console.log("El minimo son 6");
    error++
  } else {
    password.parent().find(".invalid-feedback").remove()
    password.removeClass("is-invalid")
  }

  if(!rePassword.val()){
    const errorText = getTranslationValue(config, [language, "user_rePassword_empty"],"Debes ingresar nuevamente tu contraseña");
    rePassword.removeClass("is-invalid").addClass("is-invalid")
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else if(password.val() != rePassword.val()) {
    const errorText = getTranslationValue(config, [language, "user_passwords_not_match"],"Las contraseñas no son iguales");
    rePassword.removeClass("is-invalid").addClass("is-invalid")
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.removeClass("is-invalid")
  }

  if(!error){
    const successText = getTranslationValue(config, [language, "not_error_text"],"Modificando...");
    $(this).addClass('send-button').addClass('btn-fj-purple').val(successText)
    $("#kt_login_modify_form").submit()
  }
});

/**************************************************
 * 
 *  V A L I D A C I O N E S    R E C L U T A D O R
 * 
*/
$("#kt_login_recruiter_modify_form #kt_login_recruiter_modify_submit").on("click", function(e){
  e.preventDefault()

  var error = 0
  var password = $("#kt_login_recruiter_modify_form #recruiter_password")
  var rePassword = $("#kt_login_recruiter_modify_form #recruiter_password_confirmation")

  if(!password.val()){
    const errorText = getTranslationValue(config, [language, "recruiter_empty_password"],"Debe ingresar una contraseña");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().find(".help-block").before('<div class="invalid-feedback js-error">'+errorText+'</div>')
    //console.log("No hay contraseña");
    error++
  } if(password.val().length < 6){
    const errorText = getTranslationValue(config, [language, "recruiter_short_password"],"Debe ingresar la cantidad de cararcteres indicados");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().find(".help-block").before('<div class="invalid-feedback js-error">'+errorText+'</div>')
    //console.log("El minimo son 6");
    error++
  } else {
    password.parent().find(".invalid-feedback").remove()
    password.removeClass("is-invalid")
  }

  if(!rePassword.val()){
    const errorText = getTranslationValue(config, [language, "recruiter_rePassword_empty"],"Debe ingresar nuevamente su contraseña");
    rePassword.removeClass("is-invalid").addClass("is-invalid")
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else if(password.val() != rePassword.val()) {
    const errorText = getTranslationValue(config, [language, "recruiter_passwords_not_match"],"Las contraseñas no son iguales.");
    rePassword.removeClass("is-invalid").addClass("is-invalid")
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.removeClass("is-invalid")
  }

  if(!error){
    const successText = getTranslationValue(config, [language, "not_error_text"],"Modificando...");
    $(this).addClass('send-button').addClass('btn-fj-purple').val(successText)
    $("#kt_login_recruiter_modify_form").submit()
  }
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}
	
	return currentTranslation;
}

